import React, { useState, useEffect } from 'react';
import './SplashScreen.css';

const SPLASH_SEEN_KEY = 'tlc_splash_seen';
const SPLASH_DURATION = 2000; // 2 seconds

export default function SplashScreen({ onComplete }) {
  const [isVisible, setIsVisible] = useState(true);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    // Check if splash was already seen
    const hasSeenSplash = localStorage.getItem(SPLASH_SEEN_KEY);
    if (hasSeenSplash === 'true') {
      setIsVisible(false);
      onComplete?.();
      return;
    }

    // Auto-complete after 2 seconds
    const timer = setTimeout(() => {
      handleComplete();
    }, SPLASH_DURATION);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onComplete]);

  const handleComplete = () => {
    // Mark splash as seen
    localStorage.setItem(SPLASH_SEEN_KEY, 'true');

    // Start fade out
    setIsFading(true);

    // After fade animation, hide completely
    setTimeout(() => {
      setIsVisible(false);
      onComplete?.();
    }, 400);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className={`splash-screen ${isFading ? 'fading' : ''}`} onClick={handleComplete}>
      <div className="splash-content">
        <img
          src="/logo512.png"
          alt="WiredCop"
          className="splash-logo"
        />
        <div className="splash-brand">
          <span className="splash-name">WiredCop</span>
          <span className="splash-tagline">A Public Safety-First Company</span>
        </div>
      </div>
    </div>
  );
}
